import { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { HiOutlineStar, HiStar } from "react-icons/hi";
import { IoMdClose } from "react-icons/io";
import i18next from "i18next";

import { popUpVariant } from "../animateConstant";
import { loading, loadingDestroy, notice } from "../redux/action/action";
import GetParams from "../utils/getParams";
// import { enterGame } from "../api/api";
import { closeGame, storeGameLink } from "../redux/action/game/gameAction";
import { isLoggedIn } from "../utils/isLoggedIn";
import ShowBalance from "./ShowGameComponents/ShowBalance";
import { useTranslation } from "react-i18next";

const ShowGameDetail = ({}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`gamePage.${key}`);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const gameStatus = useSelector((state) => state.isGameOpen);
  const memberData = useSelector((state) => state.isMemberInfo);

  const location = useLocation();

  const [buttonLoading, setButtonLoading] = useState(false);

  const platform = GetParams("gamePlatform");
  const code = GetParams("code");
  const type = GetParams("type");
  const en_Name = GetParams("ename");
  const zh_Name = GetParams("cname");
  const currencyType = GetParams("currency");

  const logged = isLoggedIn();

  const handleEnterGame = () => {
    dispatch(loading());
    setButtonLoading(true);

    // enterGame({
    //   platform: platform,
    //   gameCode: code,
    //   gameType: type,
    //   currencyType: currencyType,
    // })
    //   .then((data) => {
    //     if (data.code === "Ok") {
    //       setButtonLoading(false);
    //       dispatch(storeGameLink(data.url));
    //       navigate("/gamebox" + location.search);
    //     } else {
    //       dispatch(notice(data.msg, "error"));
    //       setButtonLoading(false);
    //     }
    //   })
    //   .finally(() => {
    //     dispatch(closeGame());
    //     setButtonLoading(false);
    //     dispatch(loadingDestroy());
    //   });
  };

  return (
    <AnimatePresence>
      {gameStatus && (
        <main className="fixed top-0 left-0 w-full h-full z-[9999] bg-[rgba(0,0,0,0.5)] flex items-center justify-center">
          <motion.section
            variants={popUpVariant}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{
              duration: 0.2,
            }}
            className="absolute sm:relative sm:w-[500px] sm:min-h-[400px] bottom-0 left-0 w-full min-h-[250px] rounded-t-xl bg-second-color py-[15px] px-[20px] flex flex-col justify-around z-[999999]"
          >
            <section className="flex items-start justify-between mb-[10px]">
              <section className="flex ">
                <div
                  style={{
                    backgroundImage: `url(https://boom69.com/images-webp/gameIcon/en/${platform}/${en_Name}.webp)`,
                    backgroundSize: "100% 100%",
                  }}
                  className={`w-[140px] h-[140px] rounded-[10px] bg-center bg-no-repeat mr-[15px]`}
                />
                <div className="flex flex-col text-dark-gray-text">
                  <p className="text-xl font-bold mb-[5px]">
                    {i18next.language === "zh_chs" ? zh_Name : en_Name}
                  </p>
                  <p className="text-light-text text-sm mb-[20px]">
                    {platform}
                  </p>
                  <HiStar className="text-3xl text-light-text" />

                  {logged && memberData?.basedisplaycur === "usdt" ? (
                    <ShowBalance />
                  ) : null}
                </div>
              </section>
              <IoMdClose
                onClick={() => {
                  dispatch(closeGame());
                }}
                className="text-3xl text-light-text cursor-pointer"
              />
            </section>
            <section className="flex items-center justify-between">
              {/* <Button
                disabled={buttonLoading}
                className="!bg-second-color !text-main-color w-full !mr-[10px]"
                onClick={() => {
                  handleEnterGame();
                }}
              >
                Test mode
              </Button> */}
              <Button
                disabled={buttonLoading}
                className="!bg-main-color w-full"
                onClick={() => {
                  if (!isLoggedIn()) {
                    navigate("/signin" + location.search);
                    dispatch(closeGame());
                    return;
                  }

                  handleEnterGame();
                }}
              >
                {i18n("realMode")}
              </Button>
            </section>
          </motion.section>
        </main>
      )}
    </AnimatePresence>
  );
};

export default ShowGameDetail;
